import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';

import { setServiceSearch } from '../actions';
import SearchInput from '../../../common/SearchInput';

const ServiceSearchInput = compose(
  connect(
    null,
    { setSearchTerm: setServiceSearch }
  ),
  withProps(() => ({
    placeholder: 'Search for a service...',
  })),
)(SearchInput);

export default ServiceSearchInput;
